import { render, staticRenderFns } from "./BulkRegistry.vue?vue&type=template&id=75339dcf&"
import script from "./BulkRegistry.vue?vue&type=script&lang=js&"
export * from "./BulkRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports